// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1r8cx","header":"ReportDetails_header__TcY0X","title":"ReportDetails_title__2qaKv","left":"ReportDetails_left__3iUg1"};